import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_mailcartas.pre_insercion",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
				  })
			})
	},

	consultaPoliza(p_email, p_poliza) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_mailcartas.consultaPoliza",
				"p_args_in": JSON.stringify({
                    "p_poliza": p_poliza,
				  })
			})
	},

	insertar(p_email, p_poliza, p_ecc_nuevo, p_eac_nuevo, p_codigomotivo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_mailcartas.insertar",
				"p_args_in": JSON.stringify({
                    "p_poliza": p_poliza,
					"p_ecc_nuevo" : p_ecc_nuevo,
					"p_eac_nuevo" : p_eac_nuevo,
					"p_codigomotivo" : p_codigomotivo
				  })
			})
	},

	generar_cartas(p_email, p_usuario, p_archivo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_mailcartas.leer_archivo",
				"p_args_in": JSON.stringify({
                    "p_usuario" : p_usuario,
					"p_archivo" : p_archivo
				  })
			})
	},


}